var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "flex flex-wrap md:!flex-nowrap flex-row items-center py-1/2 pb-0 md:pb-1/2 pt-0 md:pt-1/2 shadow-sm top-[0px] w-full bg-white relative z-50 roboto",
      class: [
        _vm.isSticky ? "sticky top-[0px]" : "top-[0px]",
        _vm.activeProductTab === "buy" ? "no-pad" : "",
      ],
    },
    [
      _c("div", { staticClass: "w-full shadow-sm md:shadow-none" }, [
        _c(
          "div",
          {
            staticClass:
              "mx-auto py-1/2 w-[310px] md:w-fit md:pl-0 md:ml-2 flex items-center justify-between",
          },
          [
            _c("v-button", {
              staticStyle: { margin: "0px", padding: "0" },
              attrs: {
                position: "left",
                mobile: "12",
                tablet: "12",
                desktop: "12",
                styling: "tertiary",
                textAlign: "left",
                disabled: false,
              },
              on: {
                onClickEvent: function ($event) {
                  return _vm.handleBackButtonClick()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "span",
                        { staticClass: "flex back-hover" },
                        [
                          _c("BackArrow", { attrs: { fill: "#00263E" } }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "roboto text-base text-blue-dark mt-0 font-bold ml-0 leading-none",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.activeProductInfo.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _vm.activeProductTab !== "buy"
              ? _c(
                  "span",
                  {
                    staticClass:
                      "visible-m buy-link font-normal cursor-pointer bg-blue-default text-white rounded-full text-base",
                    class: { active: _vm.activeProductTab === "buy" },
                    on: {
                      click: function ($event) {
                        return _vm.handleBuyButtonClick()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.buyButtonLanguage))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.activeProductTab !== "buy"
        ? _c(
            "div",
            {
              staticClass: "m-auto h-[60px] flex items-center md:h-fit",
              class: _vm.productTabs === 1 && "mobile-hide",
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark",
                  class: { active: _vm.activeProductTab === "overview" },
                  on: {
                    click: function ($event) {
                      return _vm.handleProductTabClick("overview")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.globals.product_nav.overview))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.productContent && _vm.productContent.features,
                      expression: "productContent && productContent.features",
                    },
                  ],
                  staticClass:
                    "hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark",
                  class: { active: _vm.activeProductTab === "features" },
                  on: {
                    click: function ($event) {
                      return _vm.handleProductTabClick("features")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.globals.product_nav.features))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.productContent && _vm.productContent.specs,
                      expression: "productContent && productContent.specs",
                    },
                  ],
                  staticClass:
                    "hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark",
                  class: { active: _vm.activeProductTab === "specs" },
                  on: {
                    click: function ($event) {
                      return _vm.handleProductTabClick("specs")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.globals.product_nav.specs))]
              ),
              _vm._v(" "),
              _vm.activeProductTab !== "buy"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "hidden-m buy-link font-normal cursor-pointer bg-blue-default text-white mx-1 rounded-full text-base md:text-lg",
                      class: { active: _vm.activeProductTab === "buy" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBuyButtonClick()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.buyButtonLanguage))]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeProductTab !== "buy"
        ? _c(
            "div",
            {
              staticClass:
                "hidden visible-m fixed bottom-0 left-0 w-full bg-white flex items-center justify-center py-1/2 border-t-1 border-gray-neutral-250",
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "font-bold cursor-pointer bg-blue-default text-white mx-1 py-1 px-2 rounded-full text-lg w-4/5 text-center",
                  class: { "font-normal": _vm.activeProductTab === "buy" },
                  on: {
                    click: function ($event) {
                      return _vm.handleBuyButtonClick()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.buyButtonLanguage))]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }